<template>
  <div id="connections">
    <div id="tab">
      <div
        class="tab"
        :class="{ active: listType == 'connected' }"
        @click="changeConnectionListType('connected')"
      >
        Connected
      </div>
      <div
        class="tab"
        :class="{ active: listType == 'received' }"
        @click="changeConnectionListType('received')"
      >
        Received <span :class="{ new: isNewReceived }"></span>
      </div>
      <div
        class="tab"
        :class="{ active: listType == 'sent' }"
        @click="changeConnectionListType('sent')"
      >
        Sent
      </div>
    </div>

    <transition name="fade">
      <comp-message
        v-if="showMessage"
        :msgText="messageText"
        :msgSuccess="!messageIsErr"
        :msgError="messageIsErr"
        @closeMsg="showMessage = false"
      />
    </transition>

    <template v-if="connectionList.length > 0">
      <comp-profile
        v-for="(item, index) in connectionList"
        :key="index"
        :profileName="item.name || 'Name Missing'"
        :photoImage="item.partnerImage"
        :hasButton="true"
        :btnInviteSent="listType === 'sent'"
        :btnInviteReceived="listType === 'received'"
        v-bind="getRelType(item.type, item.userId)"
        @click.native="clickProfile(item.connectionSeqId)"
        @acceptReceived="acceptReceived(item.connectionSeqId)"
        @deleteReceived="deleteReceived(item.connectionSeqId)"
        @resend="resend(item.userId, item.name)"
        @dismiss="dismiss(item.connectionSeqId)"
      />
    </template>
    <template v-else>
      <ul v-if="listType === 'connected'">
        No connections.
      </ul>
      <ul v-else-if="listType === 'received'">
        No new connection requests.
      </ul>
      <ul v-else-if="listType === 'sent'">
        No sent requests.
      </ul>
    </template>
    <div id="local" class="menu" v-if="showlocalMenu">
      <ul>
        <li @click="goPage('disconnect')">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
            <circle cx="12" cy="12" r="10"></circle>
            <line x1="4.93" y1="4.93" x2="19.07" y2="19.07"></line>
          </svg>
          Disconnect People
        </li>
      </ul>
    </div>

    <div
      class="btn-add"
      v-if="listType == 'connected' && isMobile && !howtoConnection"
      @click="openSelector"
    >
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
        <path d="M16 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path>
        <circle cx="8.5" cy="7" r="4"></circle>
        <line x1="20" y1="8" x2="20" y2="14"></line>
        <line x1="23" y1="11" x2="17" y2="11"></line>
      </svg>
    </div>

    <div class="modal fake" v-if="howtoConnection">
      <div class="btn-add" @click="closeSelector">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
          <line x1="18" y1="6" x2="6" y2="18"></line>
          <line x1="6" y1="6" x2="18" y2="18"></line>
        </svg>
      </div>
      <div class="btn-add btn-add-email" @click="openInviteModal('Email')">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
          <path
            d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"
          ></path>
          <polyline points="22,6 12,13 2,6"></polyline>
        </svg>
      </div>
      <div class="btn-add btn-add-qr" @click="openInviteModal('QR')">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
          <rect x="3" y="3" class="st0" width="7" height="7" />
          <rect x="14" y="3" class="st0" width="7" height="7" />
          <polyline
            class="st0"
            points="17.5,17.5 17.5,21 14,21 14,14 21,14 21,17.5 "
          />
          <rect x="3" y="14" class="st0" width="7" height="7" />
          <line class="st0" x1="6.5" y1="17.5" x2="6.5" y2="17.5" />
          <line class="st0" x1="21" y1="21" x2="21" y2="21" />
          <line class="st0" x1="6.5" y1="6.5" x2="6.5" y2="6.5" />
          <line class="st0" x1="17.5" y1="6.5" x2="17.5" y2="6.5" />
        </svg>
      </div>
    </div>

    <div class="modal" v-if="inviteConnEmail">
      <div class="modal-contents" :class="{ 'has-error': idHasError }">
        <div class="modal-header">Send Invitation to:</div>
        <div class="modal-body">
          <label class="label">{{ idMessage }}</label>
          <input type="text" placeholder="E-mail" v-model.trim="email" />
        </div>
        <div class="modal-footer">
          <div class="button-group">
            <div class="button-container">
              <div class="button" @click="closeInviteModal">Cancel</div>
            </div>
            <div class="button-container">
              <div class="button" @click="inviteCon">OK</div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="modal" v-if="inviteConnQR">
      <div class="modal-contents" :class="{ 'has-error': idHasError }">
        <div class="modal-header">Connection request</div>
        <div class="modal-body">
          <div
            class="qr"
            :style="{
              backgroundImage: `url(data:image/png;base64,${userQRImg})`
            }"
          ></div>
        </div>
        <div class="modal-footer">
          <div class="button-group">
            <div class="button-container">
              <div class="button" @click="closeInviteModal">Cancel</div>
            </div>
            <div class="button-container">
              <div class="button" @click="goPage('qr')">QR Scan</div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="modal" v-if="confirmInvite">
      <div class="modal-contents">
        <div class="modal-header">Connection requested</div>
        <div class="modal-body">
          Invitation successfully sent to {{ email }}
        </div>
        <div class="modal-footer">
          <div class="button-group">
            <div class="button" @click="closeConfirmModal">OK</div>
          </div>
        </div>
      </div>
    </div>

    <div class="modal" v-if="resendInvite">
      <div class="modal-contents">
        <div class="modal-header">Resend completed</div>
        <div class="modal-body">You have resent the invitation</div>
        <div class="modal-footer">
          <div class="button-group">
            <div class="button" @click="closeResendModal">OK</div>
          </div>
        </div>
      </div>
    </div>

    <comp-loading v-if="isLoading" :fullscreen="true"></comp-loading>
  </div>
</template>

<script>
import CompMessage from '@/components/CompMessage'
import CompProfile from '@/components/CompProfile'
import ConnectionService from '@/services/connection-service'
import common from '@/utils/common'
import CompLoading from '@/components/CompLoading.vue'

export default {
  name: 'Connections',
  mixins: [common],
  components: {
    CompProfile,
    CompMessage,
    CompLoading
  },
  data() {
    return {
      isLoading: false,
      showlocalMenu: false,

      showMessage: false,
      messageText: '',
      messageIsErr: false,

      connectionList: [],
      howtoConnection: false,
      inviteConnEmail: false,
      inviteConnQR: false,
      confirmInvite: false,
      email: '',
      friend: false,
      coworker: false,
      employee: false,
      superior: false,
      resendInvite: false,
      resendName: '',
      listType: this.$route.params.listType || 'connected',
      isNewReceived: false,
      idHasError: false,
      idMessage: '',

      userQRImg: null
    }
  },
  created() {
    this.$parent.setNav(true)
    this.$parent.setHeader('Connections')
    this.$parent.setBottomTab(true)

    this.$parent.addSomething = 'Invite People'

    this.changeConnectionListType(this.listType)

    const landingCode = this.$store.state.landingCode
    if (!this.isEmpty(landingCode)) {
      this.performConnectFromLCode(landingCode)
    }

    this.$EventBus.$on('refresh', (params) => {
      if (params.listType) this.changeConnectionListType(params.listType)
    })

    this.$EventBus.$on('open-local-menu', this.openLocalMenu)

    this.$EventBus.$on('addSomething', () => {
      this.openInviteModal('Email')
    })
  },
  computed: {
    isMobile() {
      return this.$store.state.isMobile
    }
  },
  methods: {
    getConnectionList() {
      this.isLoading = true
      this.connectionList = []

      var type
      switch (this.listType) {
        case 'received':
          type = 'invited'
          break
        case 'sent':
          type = 'sent'
          break
        default:
          type = 'joined'
      }
      ConnectionService.getConnectionList(type).then(
        ({ resultCode, resultData }) => {
          this.isLoading = false

          if (resultCode === 0) {
            this.isNewReceived = resultData.received
            this.connectionList = resultData.connectionInfoList
          }
        }
      )
    },
    performConnectFromLCode(landingCode) {
      ConnectionService.inviteFromQRcode(landingCode)
        .then(({ resultCode, resultMsg }) => {
          this.showInfoMessage(resultMsg, resultCode !== 0)
          this.getConnectionList()
        })
        .catch((error) => {
          this.showInfoMessage(error, true)
        })
      this.$store.commit('clearLandingCode')
    },
    closeConfirmModal() {
      this.confirmInvite = false
      this.email = ''
    },
    closeResendModal() {
      this.resendInvite = false
      this.getConnectionList()
    },
    closeInviteModal() {
      this.closeSelector()
      this.inviteConnEmail = false
      this.inviteConnQR = false
    },
    openInviteModal(modalType) {
      if (modalType === 'QR') {
        ConnectionService.getQrCode().then(({ resultCode, resultData }) => {
          if (resultCode === 0 && !this.isEmpty(resultData)) {
            this.userQRImg = resultData.qrImage
          }
        })

        this.inviteConnEmail = false
        this.inviteConnQR = true
      } else {
        this.inviteConnEmail = true
        this.inviteConnQR = false
      }
    },
    openSelector() {
      this.howtoConnection = true
    },
    closeSelector() {
      this.howtoConnection = false
    },
    deleteCon() {
      this.isLoading = true

      ConnectionService.deleteCon().then(({ resultCode, resultMsg }) => {
        this.isLoading = false
        this.showInfoMessage(resultMsg, resultCode !== 0)
      })
    },
    inviteCon() {
      this.isLoading = true

      const param = {
        userIdList: this.email
      }
      ConnectionService.inviteCon(param).then((data) => {
        this.isLoading = false

        if (data.resultCode === 0) {
          this.inviteConnEmail = false
          this.confirmInvite = true
        } else {
          this.idMessage = data.resultMsg
          this.idHasError = true
        }
      })
    },
    clickProfile(connectionSeqId) {
      if (this.listType === 'connected') {
        this.goPage(`connectionbrief/${connectionSeqId}`)
      }
    },
    acceptReceived(param) {
      this.isLoading = true

      ConnectionService.acceptCon(param).then(({ resultCode, resultMsg }) => {
        this.isLoading = false
        this.showInfoMessage(resultMsg, resultCode !== 0)

        if (resultCode === 0) {
          this.getConnectionList()
        }
      })
    },
    deleteReceived(param) {
      this.isLoading = true

      ConnectionService.rejectCon(param).then(({ resultCode, resultMsg }) => {
        this.isLoading = false
        this.showInfoMessage(resultMsg, resultCode !== 0)

        if (resultCode === 0) {
          this.getConnectionList()
        }
      })
    },
    resend(email, name) {
      this.isLoading = true

      const param = {
        userIdList: email
      }
      ConnectionService.inviteCon(param).then(({ resultCode, resultMsg }) => {
        this.isLoading = false

        if (resultCode === 0) {
          this.resendName = name
          this.resendInvite = true
        } else {
          this.showInfoMessage(resultMsg, true)
        }
      })
    },
    dismiss(param) {
      this.isLoading = true

      ConnectionService.deleteCon(param).then(({ resultCode, resultMsg }) => {
        this.isLoading = false

        if (resultCode === 0) {
          this.getConnectionList()
        } else {
          this.showInfoMessage(resultMsg, true)
        }
      })
    },
    getRelType(type, userId) {
      if (this.listType === 'connected') {
        if (type === 'Peer') {
          return { relType1: true, profileSub: type }
        } else if (type === 'Coworker') {
          return { relType2: true, profileSub: type }
        } else if (type === 'Employee') {
          return { relType3: true, profileSub: type }
        } else if (type === 'Supervisor') {
          return { relType4: true, profileSub: type }
        } else {
          return { relUndefined: true, profileSub: type }
        }
      } else {
        return { profileSub: userId }
      }
    },
    openLocalMenu() {
      if (this.showlocalMenu === true) {
        this.showlocalMenu = false
      } else {
        this.showlocalMenu = true
      }
    },
    showInfoMessage(message, isError) {
      this.showMessage = true
      this.messageText = message
      this.messageIsErr = isError || false

      setTimeout(() => {
        this.showMessage = false
        this.messageText = ''
        this.messageIsErr = false
      }, 2000)
    },
    changeConnectionListType(listType) {
      this.connectionList = []

      this.$parent.headerMenu = listType === 'connected'

      this.listType = listType
      this.$store.state.selectedSubMenu = listType

      this.getConnectionList()
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" src="@/scss/connections.scss" scoped></style>
